import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Group = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M11.985 8.985a6.396 6.396 0 1 0 0 12.793 6.396 6.396 0 0 0 0-12.793Zm-8.469 6.396a8.468 8.468 0 1 1 16.937 0 8.468 8.468 0 0 1-16.937 0ZM11.985 28.671a9.458 9.458 0 0 0-9.464 9.463v3.399c0 .45.365.815.816.815h17.296c.45 0 .815-.365.815-.815v-3.399a9.458 9.458 0 0 0-9.463-9.463ZM.449 38.134C.45 31.76 5.61 26.6 11.985 26.6c6.374 0 11.535 5.16 11.535 11.535v3.399a2.887 2.887 0 0 1-2.887 2.887H3.337a2.887 2.887 0 0 1-2.888-2.887v-3.399ZM32.016 2.492a6.396 6.396 0 1 0 0 12.793 6.396 6.396 0 0 0 0-12.793Zm-8.468 6.396a8.468 8.468 0 1 1 16.936 0 8.468 8.468 0 0 1-16.937 0ZM32.016 22.164a9.456 9.456 0 0 0-6.714 2.791 1.036 1.036 0 0 1-1.465-1.465 11.529 11.529 0 0 1 8.179-3.398c6.374 0 11.535 5.161 11.535 11.536v3.398a2.887 2.887 0 0 1-2.887 2.887H29.502a1.036 1.036 0 1 1 0-2.072h11.162c.45 0 .815-.365.815-.815v-3.399a9.458 9.458 0 0 0-9.463-9.463Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
Group.displayName = 'Group';
Group.defaultProps = {
  'aria-label': 'Group'
};
export default Group;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Group.js
// module id = 3808
// module chunks = 11